export default `
    <hr id="#=data.id#" class= "#=data.vertical || "horizontal-seperator"# #: data.classes || "" # #=data.bsc||""#" style= "#= data.style || "" #" />
`;
